<div class="form-check form-switch" *ngIf="type === 'BOOL'">
  <input type="checkbox" class="form-check-input medium" [ngModel]="val" (ngModelChange)="onChange($event)" />
</div>
<input *ngIf="type === 'INT'" [ngModel]="val" type="number" class="form-control" (ngModelChange)="onChange($event)">
<textarea *ngIf="type ===  'STR'" [ngModel]="val" class="form-control" (ngModelChange)="onChange($event)" [attr.rows]="rowsCount"></textarea>
